import React, { useState } from "react";
import { db } from "../../firebase";
import { useAuth } from "../AuthProvider";
import {
  collection,
  addDoc,
  doc,
  updateDoc,
  serverTimestamp,
  arrayUnion,
} from "firebase/firestore";
import { Input } from "../input";
import { Textarea } from "../textarea";
import { Button } from "../button";
import { Text } from "../text";
import { Subheading } from "../heading";
import { Listbox, ListboxOption } from "../listbox";
import { showAlert } from "../../alertService";
import { PaperAirplaneIcon } from "@heroicons/react/20/solid";

const ACCENT = "#1b4d2e";

const SupportTicketForm = ({ onTicketSubmitted }) => {
  const { user, userInfo } = useAuth();
  const subjectOptions = [
    { value: "", label: "Selecciona un asunto...", disabled: true },
    { value: "Agendar cita", label: "Agendar cita" },
    { value: "Pedir soporte", label: "Pedir soporte" },
    { value: "Pedir feature", label: "Pedir feature" },
    { value: "Otro", label: "Otro" },
  ];
  const [subject, setSubject] = useState("");
  const [customSubject, setCustomSubject] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!subject || !message) return;

    setLoading(true);
    setSuccess("");
    try {
      // Create ticket in ticketsUsuarios
      const ticketRef = await addDoc(collection(db, "ticketsUsuarios"), {
        userId: user.uid,
        userName: userInfo.name || "",
        userEmail: userInfo.email || "",
        subject: subject === "Otro" ? customSubject : subject,
        message,
        status: "open",
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp(),
      });

      // Add ticket ID to user's tickets array
      await updateDoc(doc(db, "users", user.uid), {
        tickets: arrayUnion(ticketRef.id),
      });

      setSubject("");
      setCustomSubject("");
      setMessage("");
      setSuccess("¡Ticket enviado!");
      showAlert("¡Ticket enviado!", "success");
      if (onTicketSubmitted) onTicketSubmitted();
    } catch (err) {
      alert("Error enviando ticket");
      showAlert("Error enviando ticket", "error");
    }
    setLoading(false);
  };

  return (
    <div className="rounded-xl border border-zinc-200 bg-white p-6 shadow-sm dark:border-zinc-700/60 dark:bg-zinc-800/50">
      <div className="flex items-center gap-2.5 mb-5">
        <div
          className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg"
          style={{ backgroundColor: ACCENT + "1a" }}
        >
          <PaperAirplaneIcon className="h-4 w-4" style={{ color: ACCENT }} />
        </div>
        <Subheading level={2}>Enviar Ticket de Soporte</Subheading>
      </div>
      <form onSubmit={handleSubmit} className="space-y-4">
        <Listbox value={subject} onChange={setSubject}>
          {subjectOptions.map((option) => (
            <ListboxOption
              key={option.value}
              value={option.value}
              disabled={option.disabled}
            >
              {option.label}
            </ListboxOption>
          ))}
        </Listbox>
        {subject === "Otro" && (
          <Input
            placeholder="Especifica el asunto"
            value={customSubject}
            onChange={(e) => setCustomSubject(e.target.value)}
            required
          />
        )}
        <Textarea
          placeholder="Describe tu problema o solicitud..."
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          rows={4}
          required
        />
        <Button
          type="submit"
          disabled={loading}
          className="!text-white"
          style={{ backgroundColor: ACCENT }}
        >
          {loading ? "Enviando..." : "Enviar Ticket"}
        </Button>
        {success && (
          <Text className="font-medium" style={{ color: ACCENT }}>
            {success}
          </Text>
        )}
      </form>
    </div>
  );
};

export default SupportTicketForm;
